import * as React from 'react';

const AdminGroup = React.lazy(() => import('./presenter'));

export default () => <AdminGroup />;
